import React, { useEffect, useState } from "react";
import { Header } from "../../../components/SpearParts/Layouts/Header";
import "bootstrap/dist/css/bootstrap.min.css";
import SEO from "../../../components/SEO";
import {

  Card,
  Button,
  Container,
  Row,
  Col,
  Tab,
  Tabs,
  Image,
  InputGroup,
  Form,
} from "react-bootstrap";
import { toTitleCase } from "../../../components/utils/StringUtil";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import Axios from "../../../axios/axios";
import ReviewModal from "../../Product/ReviewModal";
import ReviewCarousel from "../../Product/ReviewCarousel";
import CatalogueCard from "../../Product/CatalogueCard";
import { Footer } from "../../../components/SpearParts/Layouts/Footer";
import { Helmet } from "react-helmet-async";
import ImageZoom from "react-image-zoom";
import TopNavBar from "../../../components/SpearParts/Layouts/TopNavBar";
import TopSearchBar from "../../../components/SpearParts/Layouts/TopSearchBar";

const OthersSingleProduct = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const location = useLocation();
  const [reviews, setReviews] = useState([]);
  const { id } = useParams();
  const [quantity, setQuantity] = useState(1);
  const [message, setMessage] = useState("");
  const [isInCart, setIsInCart] = useState(false);
  const navigate = useNavigate();
  const handleLoginRedirect = () => {
    sessionStorage.setItem("postLoginRedirect", location.pathname);
    navigate(`/login?redirect=${encodeURIComponent(location.pathname)}`);
  };

  const [brand, setBrand] = useState([]);
  const [region, setRegion] = useState([]);
  const [model, setModel] = useState([]);
  const [bldmeterial, setBldMeterial] = useState([]);
  const [userInfo, setUserInfo] = useState(null);
  const [manufacturer, setManufacturer] = useState(null);

  const modelId = bldmeterial?.modelId?._id;
  const brandId = bldmeterial?.brandId?._id;

  const [mainImage, setMainImage] = useState(
    bldmeterial?.photos?.[0]?.url || ""
  );
  const [tab, setTab] = useState("features");
  const [relatedProducts, setRelatedProducts] = useState([]);

  const product = {
    title: "Aurora Wireless Headphones — Noise Cancelling",
    brand: "Aurora Audio",
    price: 129.99,
    oldPrice: 179.99,
    rating: 4.6,
    reviewsCount: 248,
    badges: ["Bestseller", "Limited Offer"],
    images: [
      "/images/headphone-1.jpg",
      "/images/headphone-2.jpg",
      "/images/headphone-3.jpg",
      "/images/headphone-4.jpg",
    ],
    features: [
      "Active Noise Cancellation (ANC)",
      "30 hours battery life",
      "Quick charge: 10 min = 5 hours",
      "Bluetooth 5.3 with multipoint",
      "Lightweight & foldable design",
    ],
    catalogs: [
      { name: "Specs Sheet (PDF)", href: "/files/specs-aurora.pdf" },
      { name: "Warranty & Manual", href: "/files/manual-aurora.pdf" },
    ],
    reviews: [
      {
        name: "Priya",
        rating: 5,
        date: "2025-09-15",
        text: "Amazing ANC and very comfortable for long use.",
      },
      {
        name: "Rahul",
        rating: 4,
        date: "2025-08-30",
        text: "Great sound but could be lighter. Battery excellent.",
      },
      {
        name: "Maya",
        rating: 5,
        date: "2025-07-12",
        text: "Best in this price range. Highly recommend.",
      },
    ],
  };

  useEffect(() => {
    if (bldmeterial?.photos?.length > 0) {
      setMainImage(bldmeterial.photos[0].url); // Set only the first image as the main image
    }
  }, [bldmeterial]);

  useEffect(() => {
    LoginData();
  }, []);

  useEffect(() => {
    getProductData();
    fetchReview();
  }, [id]);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id, location.pathname]);

  useEffect(() => {
    // if (bldmeterial.brandId) getBrand();
    // if (bldmeterial.modelId) getModel();
    if (bldmeterial.regionId) getRegion();
  }, [bldmeterial]);

  useEffect(() => {
    if (bldmeterial?._id && userInfo?.customerId) {
      checkCart();
    }
  }, [bldmeterial, userInfo]);

  const LoginData = () => {
    const userInfoString = sessionStorage.getItem("userInfo");
    if (userInfoString) {
      setUserInfo(JSON.parse(userInfoString));
    }
  };

  // useEffect(() => {
  //   const fetchManufacturer = async () => {
  //     try {
  //       if (bldmeterial?.manufacturer) {
  //         const res = await Axios.get(`/manufacturer/get/${bldmeterial.manufacturer}`);
  //         setManufacturer(res.data); // Contains manufacturerName, email, etc.
  //       }
  //     } catch (err) {
  //       console.error("Failed to fetch manufacturer:", err);
  //     }
  //   };

  //   fetchManufacturer();
  // }, [bldmeterial?.manufacturer]);

  const getProductData = async () => {
    try {
      const res = await Axios.get(`/meterials/get/${id}`);
      console.log("Fetched Material Data:", res.data); // Debugging
      setBldMeterial(res.data);

      // Fetch brand and model only after setting the material
      // if (res.data.brandId) getBrand(res.data.brandId);
      // if (res.data.modelId) getModel(res.data.modelId);
    } catch (error) {
      console.error("Error fetching product data", error);
    }
  };

  useEffect(() => {
    async function fetchBrand() {
      try {
        const response = await Axios.get(`/brand/get/${brandId}`);
        setBrand(response.data);
      } catch (error) {
        console.error("Error fetching brand:", error);
      }
    }

    if (brandId) {
      fetchBrand();
    }
  }, [brandId]);

  useEffect(() => {
    async function fetchModel() {
      try {
        const response = await Axios.get(`/model/getsingle/${modelId}`);
        setModel(response.data); // Ensure this sets `model`
      } catch (error) {
        console.error("Error fetching model:", error);
      }
    }

    if (modelId) {
      fetchModel();
    }
  }, [modelId]);
  useEffect(() => {
    const fetchRelatedMaterials = async () => {
      if (!bldmeterial?._id || !bldmeterial?.categoryId?._id) return;
      try {
        const res = await Axios.get(
          `/related-materials?categoryId=${bldmeterial.categoryId._id}&excludeId=${bldmeterial._id}`
        );
        setRelatedProducts(
          Array.isArray(res.data) ? res.data : res.data.products || []
        );
      } catch (err) {
        console.error("Error fetching related building materials:", err);
      }
    };

    fetchRelatedMaterials();
  }, [bldmeterial]);

  const getRegion = async () => {
    try {
      const result = await Axios.get(`/region/get/${bldmeterial.regionId}`);
      setRegion(result.data);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchReview = async () => {
    try {
      const response = await Axios.get(`review/search?partsId=${id}`);
      const reviewsData = response.data;

      const reviewsWithName = await Promise.all(
        reviewsData.map(async (review) => {
          let customerName = "Unknown";

          if (review.customerId) {
            try {
              const res = await Axios.get(`/customer/get/${review.customerId}`);
              customerName = res.data?.customerName || "Unknown";
            } catch (err) {
              console.error("Error fetching customer:", err);
            }
          }

          return {
            ...review,
            customerName,
            createdAt: review.createdAt || null,
          };
        })
      );

      setReviews(reviewsWithName);
    } catch (error) {
      console.error("Error fetching reviews:", error);
    }
  };
  const checkCart = async () => {
    try {
      const res = await Axios.get(
        `/cart/check/${bldmeterial?._id}/${userInfo?.customerId}`
      );
      setIsInCart(res.data.exists);
    } catch (error) {
      console.error("Error checking cart status", error);
    }
  };
  console.log(isInCart);

  const addToCart = async () => {
    try {
      // Create a cart object payload
      const cartData = {
        customerId: userInfo?.customerId, // Replace or retrieve from context/authentication
        businessType: "retail", // Example; adjust accordingly
        items: [
          {
            productId: bldmeterial?._id, // assuming productId is from params or part
            productName: bldmeterial?.meterialName || "Product Name", // You might need to adjust
            productType: bldmeterial?.productType,
            quantity: quantity,
            unitPrice: bldmeterial?.pricePerUnit || 0,
            totalItemPrice: (bldmeterial?.pricePerUnit || 0) * quantity,
          },
        ],
        tax: 5, // or calculate tax as per your business logic
      };

      console.log(cartData);

      // Send POST request to create a new cart (or add item to an existing one)
      const response = await Axios.post("/cart/create", cartData);
      setMessage("Product added to cart successfully!");
      setIsInCart(true);
    } catch (error) {
      console.error("Error adding to cart:", error);
      setMessage("Error adding product to cart.");
    }
  };
  const today = new Date();
  const formattedDate = today.toISOString().split("T")[0];

  const addToOrder = async () => {
    try {
      const orderData = {
        customerId: userInfo?.customerId,
        customerName: userInfo?.username,
        orderDate: formattedDate,
        deliveryDate: "",
        orderStatus: "orderplaced",
        paymentStatus: "pending",
        currency: "INR",
        orderItems: [
          {
            meterialId: bldmeterial?._id,
            meterialName: bldmeterial?.meterialName || "Material Name",
            quantity: quantity,
            unitPrice: bldmeterial?.pricePerUnit || 0,
            totalPrice: (bldmeterial?.pricePerUnit || 0) * quantity,
            supplier: bldmeterial?.supplier.name,
          },
        ],
        tax: 10,
      };

      const response = await Axios.post("/order/create", orderData);
      setMessage("Building material order placed successfully!");
    } catch (error) {
      console.error("Error adding order:", error);
      setMessage("Error placing building material order.");
    }
  };

  const calculateAverageRating = (reviews) => {
    if (!reviews || reviews.length === 0) return "No reviews yet";
    const totalRating = reviews.reduce((sum, review) => sum + review.rating, 0);
    return (totalRating / reviews.length).toFixed(1);
  };

  const handleQuantityChange = (amount) => {
    setQuantity((prev) => Math.max(1, prev + amount));
  };

  const sectionStyle = {
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundImage: "url(/images/bnr-bg.png)",
  };

  const beforeImageStyle = {
    content: '""',
    position: "absolute",
    left: 0,
    top: 0,
    width: "360px",
    height: "100%",
    backgroundImage: "url(/images/others.png)",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "left top",
    backgroundSize: "contain",
    pointerEvents: "none",
    zIndex: 1,
  };
  return (
    <div className="New-Rnt-Dashboard" style={sectionStyle}>
     {bldmeterial?._id && (
  <SEO
    title={
      bldmeterial.seo?.metaTitle ||
      `${bldmeterial.meterialName} | Asia Parts`
    }
    description={
      bldmeterial.seo?.metaDescription ||
      bldmeterial.description ||
      "Buy high quality building materials from Asia Parts"
    }
    keywords={
      Array.isArray(bldmeterial.seo?.metaKeywords)
        ? bldmeterial.seo.metaKeywords.join(", ")
        : ""
    }
    canonical={`https://asiapartsouq.com/others/product/single/${bldmeterial.slug || bldmeterial._id}`}
    ogImage={
      bldmeterial.photos?.[0]?.url ||
      "https://asiapartsouq.com/images/no-image.jpg"
    }
    ogUrl={`https://asiapartsouq.com/others/product/single/${bldmeterial.slug || bldmeterial._id}`}
  />
)}

      <div className="before-image" style={beforeImageStyle}></div>
      {/* <Header /> */}
      <div className="Main-div">
        <TopNavBar />
        <div className="TopSearchBar">
          <TopSearchBar />
        </div>
        <div className="single-product-container container py-4">
          <style>{`
          .single-product-card{background:linear-gradient(180deg,#fff,#fbfdff);border-radius:12px;padding:18px;box-shadow:0 6px 20px rgba(33,37,41,0.06)}
          .product-gallery{min-height:320px}
          .thumb-img{height:64px;object-fit:cover;border-radius:8px;border:1px solid transparent;cursor:pointer}
          .thumb-img.selected{border-color:#1b52a3}
          .main-img{width:100%;height:100%;object-fit:contain;border-radius:8px}
          .price-row{display:flex;align-items:center;gap:.75rem}
          .old-price{text-decoration:line-through;color:#8a8d93}
          .badge-modern{background:#eef6ff;color:#0b5ed7;padding:4px 8px;border-radius:999px;font-weight:600;font-size:.8rem}
          .pill{display:inline-block;padding:.25rem .6rem;border-radius:999px;background:#f3f6f9;color:#253047;font-size:.78rem}
          .tab-btn{border:none;background:transparent;padding:.5rem 1rem;cursor:pointer}
          .tab-btn.active{border-bottom:3px solid #1b52a3}
          .specs-list li{padding:.25rem 0}
          .review{border-top:1px solid #eef2f6;padding:12px 0}
          .related-card{border-radius:10px;overflow:hidden}

          /* Responsive tweaks */
          @media (max-width: 767.98px){
            .product-gallery{min-height:220px}
            .thumb-img{height:52px}
          }
        `}</style>

          <button
            className="btn btn-sm btn-outline-secondary mb-3 d-inline-flex align-items-center gap-1 shadow-sm"
            style={{
              borderRadius: "6px",
              padding: "4px 10px",
              fontSize: "13px",
              fontWeight: "500",
            }}
            onClick={() => navigate(-1)}
          >
            <i className="fa fa-arrow-left" aria-hidden="true" style={{ fontSize: "11px" }}></i>
            <span>Back</span>
          </button>

          <div
            className="single-product-card row gx-4 align-items-start"
            // style={{ marginTop: "120px" }}
          >
            {/* Left: Gallery */}
            <div className="col-12 col-lg-6">
              <div className="product-gallery p-2 d-flex flex-column gap-2">
                <div
                  className="ratio ratio-4x3 bg-white p-3 d-flex align-items-center justify-content-center"
                  style={{ borderRadius: 10 }}
                >
                  <img
                    src={mainImage || "/images/no-image.jpg"}
                    alt={bldmeterial.meterialName}
                    className="main-img"
                    onError={(e) => (e.target.src = "/images/no-image.jpg")}
                  />
                </div>
                <div className="d-flex gap-2 mt-2 overflow-auto">
                  {bldmeterial?.photos?.map((image, index) => (
                    <img
                      key={index}
                      src={image.url}
                      alt={`thumb-${index}`}
                      onClick={() => setMainImage(image.url)}
                      className={`thumb-img ${
                        mainImage === image.url ? "selected" : ""
                      }`}
                      style={{ width: 80 }}
                    />
                  ))}
                </div>
              </div>
            </div>

            {/* Right: Details */}
            <div className="col-12 col-lg-6">
              <div className="p-2">
                <h2 style={{ marginBottom: 6, fontSize: 22 }}>
                  {toTitleCase(bldmeterial.meterialName)}
                </h2>
                <div className="text-muted" style={{ fontSize: 13 }}>
                  {toTitleCase(brand?.name)}
                </div>
                <div className="d-flex justify-content-between align-items-start">
                  <div>
                    <div style={{ fontSize: 14, fontWeight: 700 }}>
                      {" "}
                      {calculateAverageRating(reviews)} ⭐
                    </div>
                    <div style={{ fontSize: 12, color: "#6c757d" }}>
                      {" "}
                      {reviews.length} reviews
                    </div>
                  </div>
                </div>
                <div className="mt-3">
                  <div className="price-row">
                    <div style={{ fontSize: 24, fontWeight: 800 }}>
                      Request for price
                    </div>
                  </div>
                </div>
                <div className="mt-2 d-flex gap-2">
                  {product.badges.map((b, i) => (
                    <div key={i} className="badge-modern">
                      {b}
                    </div>
                  ))}
                </div>
                <div className="mt-4 d-flex gap-2 align-items-center">
                  {userInfo ? (
                    !isInCart ? (
                      <>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 8,
                          }}
                        >
                          <button
                            className="btn btn-outline-secondary"
                            onClick={() => handleQuantityChange(-1)}
                          >
                            -
                          </button>
                          <input
                            type="number"
                            value={quantity}
                            onChange={(e) =>
                              setQuantity(
                                Math.max(1, Number(e.target.value) || 1)
                              )
                            }
                            style={{ width: 72, textAlign: "center" }}
                            className="form-control"
                          />
                          <button
                            className="btn btn-outline-secondary"
                            onClick={() => handleQuantityChange(1)}
                          >
                            +
                          </button>
                        </div>
                        <button
                          className="btn btn-primary"
                          style={{ minWidth: 160 }}
                          onClick={addToCart}
                        >
                          Add to Cart
                        </button>
                      </>
                    ) : (
                      <Link to={`/viewcart/${bldmeterial?._id}`}>
                        <button
                          className="btn btn-primary"
                          style={{ minWidth: 160 }}
                        >
                          View Cart
                        </button>
                      </Link>
                    )
                  ) : (
                    <button
                      className="btn btn-primary"
                      style={{
                        minWidth: 220,
                        backgroundColor: "#1a53a4",
                        border: "none",
                        minHeight: "40px",
                      }}
                      onClick={handleLoginRedirect}
                    >
                      Login For Request
                    </button>
                  )}
                </div>

                <div className="mt-3 d-flex flex-column gap-2">
                  <small className="text-muted">
                    <span>
                      Category:{" "}
                      <span className="text-secondary fw-bold">
                        {toTitleCase(bldmeterial?.categoryId?.name)}
                      </span>
                    </span>
                  </small>
                  <small className="text-muted">
                    <span
                      className="text-secondary fw-bold"
                      style={{
                        fontSize: "15px",
                        fontFamily: "revert-layer",
                        textAlign: "justify",
                        display: "inline-block",
                        maxWidth: "100%",
                      }}
                    >
                      {bldmeterial?.description || "No description available."}
                    </span>
                  </small>
                  <small className="text-muted">
                    <strong>Part Number:</strong>{" "}
                    <span className="text-secondary fw-bold">
                      {toTitleCase(bldmeterial.partNo)}
                    </span>
                  </small>
                  {bldmeterial?.manufacturer?.manufacturerName && (
                    <small className="text-muted">
                      Manufacturer:{" "}
                      <span className="text-secondary fw-bold">
                        {toTitleCase(bldmeterial.manufacturer.manufacturerName)}
                      </span>
                    </small>
                  )}
                </div>
              </div>
            </div>

            {/* Tabs */}
            <div className="col-12 mt-3">
              <div className="d-flex border-bottom" style={{ gap: 12 }}>
                <button
                  className={`tab-btn ${tab === "features" ? "active" : ""}`}
                  onClick={() => setTab("features")}
                >
                  Features
                </button>
                <button
                  className={`tab-btn ${tab === "catalogs" ? "active" : ""}`}
                  onClick={() => setTab("catalogs")}
                >
                  Catalogs
                </button>
                <button
                  className={`tab-btn ${tab === "reviews" ? "active" : ""}`}
                  onClick={() => setTab("reviews")}
                >
                  Reviews ({reviews.length})
                </button>
              </div>
              <div className="tab-content p-3">
                {tab === "features" && (
                  <div className="row">
                    <div className="col-md-6">
                      <ul className="specs-list">
                        <li>
                          Brand: <b>{toTitleCase(brand.name)}</b>
                        </li>
                        <li>
                          Model: <b>{toTitleCase(model?.name)}</b>
                        </li>
                        <li>
                          Region:{" "}
                          <b>{toTitleCase(bldmeterial?.regionId?.name)}</b>
                        </li>
                        <li>
                          Material Name:{" "}
                          <b>{toTitleCase(bldmeterial.meterialName)}</b>
                        </li>
                      </ul>
                    </div>
                    <div className="col-md-6">
                      <ul className="specs-list">
                        <li>
                          Body Type: <b>{toTitleCase(bldmeterial.bodyType)}</b>
                        </li>
                        <li>
                          Engine: <b>{toTitleCase(bldmeterial.engine)}</b>
                        </li>
                        <li>
                          Transmission Type:{" "}
                          <b>{toTitleCase(bldmeterial.transmissionType)}</b>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}

                {tab === "catalogs" && (
                  <div className="d-flex flex-column flex-sm-row gap-2">
                    {Array.isArray(bldmeterial?.catalogue) &&
                    bldmeterial.catalogue.length > 0 ? (
                      bldmeterial.catalogue.map((item, i) => (
                        <CatalogueCard key={i} item={item} />
                      ))
                    ) : (
                      <img
                        src="/images/no-data.avif"
                        style={{ width: "250px", marginLeft: "30%" }}
                      />
                    )}
                  </div>
                )}

                {tab === "reviews" && (
                  <div>
                    <ReviewCarousel reviews={reviews} />

                    {/* ✅ Add this mapping block here */}
                    {reviews.map((r, i) => (
                      <div key={i} className="review">
                        <div className="d-flex justify-content-between align-items-start">
                          <div>
                            <strong>{r.customerName}</strong>
                            <div style={{ fontSize: 13, color: "#6c757d" }}>
                              {r.createdAt
                                ? new Date(r.createdAt).toLocaleDateString()
                                : "Date not available"}
                            </div>
                          </div>
                          <div style={{ fontWeight: 700 }}>{r.rating} ⭐</div>
                        </div>
                        <p style={{ marginTop: 8 }}>{r.note}</p>
                      </div>
                    ))}

                    {userInfo && (
                      <button
                        className="btn btn-primary mt-2"
                        style={{ backgroundColor: "#1a54a6" }}
                        onClick={() => setIsModalOpen(true)}
                      >
                        Add Review
                      </button>
                    )}
                    <ReviewModal
                      isOpen={isModalOpen}
                      onClose={() => setIsModalOpen(false)}
                      id={id}
                      userInfo={userInfo}
                      setReviews={setReviews}
                      fetchReview={fetchReview} // ✅ pass this
                    />
                  </div>
                )}
              </div>
            </div>

            {/* Related Products */}
            <div className="col-12 mt-4">
              <h5>Related products</h5>
              <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3 mt-2">
                {relatedProducts?.length > 0 ? (
                  relatedProducts?.map((p) => (
                    <div key={p._id} className="col">
                      <div className="card related-card p-2 h-100">
                        <img
                          src={p.photos?.[0]?.url || "/images/no-image.jpg"}
                          alt={p.meterialName}
                          onError={(e) =>
                            (e.target.src = "/images/no-image.jpg")
                          }
                          style={{
                            height: 140,
                            width: "100%",
                            objectFit: "cover",
                          }}
                        />

                        <div className="card-body p-2">
                          <h6 className="card-title mb-1">{p.meterialName}</h6>
                          <div className="d-flex justify-content-between align-items-center">
                            <div style={{ fontWeight: 700 }}>
                              Request for Price
                              {/* {p.pricePerUnit
                              ? `₹${p.pricePerUnit}`
                              : "Request for price"} */}
                            </div>
                            <Link to={`/others/product/single/${p._id}`}>
                              <button className="btn btn-sm btn-outline-primary">
                                View
                              </button>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="text-muted">No related products found.</div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OthersSingleProduct;
